import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateUserPassword } from "../../services/user.service";
import Swal from "sweetalert2";
import { ATLEAST_ONE_CAPITAL_REGEX, ATLEAST_ONE_NUMBER_REGEX, ATLEAST_ONE_SMALL_REGEX, ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, SWAL_SETTINGS } from "../../../../utils/Constants";
import { changePassword } from "../../../advertiser/services/user.service";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function ChangePassword() {
  const { t } = useTranslation();
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const location = useLocation();


  const validationSchema = Yup.object({
    old_password: Yup.string().required(t("vaildation.old_password")),
    new_password: Yup.string()
      // .min(6, "Password should be at least 6 characters")
      .matches(ATLEAST_ONE_SMALL_REGEX, t("vaildation.one_small_letter"))
      .matches(ATLEAST_ONE_CAPITAL_REGEX, t("vaildation.one_capital_letter"))
      .matches(ATLEAST_ONE_NUMBER_REGEX, t("vaildation.one_number"))
      .matches(ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, t("vaildation.one_special_char"))
      .min(PASSWORD_MIN_LENGTH, t("vaildation.min_length"))
      .max(PASSWORD_MAX_LENGTH, t("vaildation.max_length"))
      .required(t("vaildation.new_password"))
      .notOneOf([Yup.ref("old_password")], t("vaildation.password_same_as_old")),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("new_password")], t("vaildation.passwords_must_match"))
      .required(t("vaildation.confirm_password")),
  });
  const formik = useFormik({
    initialValues: {
      old_password: "",
      new_password: "",
      confirm_password: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = location.pathname.includes('advertiser')? await changePassword(values) : await updateUserPassword(values);

        if (response.success) {
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
          resetForm();
        } else {
          Swal.fire({
            icon: "error",
            text: response.message,
            ...SWAL_SETTINGS,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  return (
    <div className="edit-profile-bg py-10">
      <div className="container">
        <div className="max-w-[797px] mx-auto">
          <h1 className="headings-h1 text-zinc-950 border-b border-gray-200 pb-[15px] mb-[30px]">{t("change_password")}</h1>

          <div className="bg-white border-1 border-zinc-100 p-[15px] md:p-[30px] lg:p-[50px] shadow rounded-[10px]">
            <form onSubmit={formik.handleSubmit} className="edit-profile-form-bg">
              {/* Old Password */}
              <div className="form-group relative">
                <label>{t("old_password")}</label>
                <input onKeyDown={(e) => {
                  if (e.key === " ") e.preventDefault();
                }} type={showOld ? "text" : "password"} name="old_password" placeholder={t("placeholder.password")} className="form-control-custom" value={formik.values.old_password} onChange={formik.handleChange} />

                <i className={`ri-${showOld ? "eye-off-line" : "eye-line"} absolute right-3 top-9 cursor-pointer text-xl`} onClick={() => setShowOld(!showOld)}></i>

                {formik.errors.old_password && <p className="error-text text-danger">{formik.errors.old_password}</p>}
              </div>

              {/* New Password */}
              <div className="form-group relative">
                <label>{t("new_password")}</label>
                <input onKeyDown={(e) => {
                  if (e.key === " ") e.preventDefault();
                }} type={showNew ? "text" : "password"} name="new_password" placeholder={t("placeholder.new_password")} className="form-control-custom" value={formik.values.new_password} onChange={formik.handleChange} />

                <i className={`ri-${showNew ? "eye-off-line" : "eye-line"} absolute right-3 top-9 cursor-pointer text-xl`} onClick={() => setShowNew(!showNew)}></i>

                {formik.errors.new_password && <p className="error-text text-danger">{formik.errors.new_password}</p>}
              </div>

              {/* Confirm Password */}
              <div className="form-group relative">
                <label>{t("confirm_new_password")}</label>
                <input onKeyDown={(e) => {
                  if (e.key === " ") e.preventDefault();
                }} type={showConfirm ? "text" : "password"} name="confirm_password" placeholder={t("placeholder.confirm_new_password")} className="form-control-custom" value={formik.values.confirm_password} onChange={formik.handleChange} />

                <i className={`ri-${showConfirm ? "eye-off-line" : "eye-line"} absolute right-3 top-9 cursor-pointer text-xl`} onClick={() => setShowConfirm(!showConfirm)}></i>

                {formik.errors.confirm_password && <p className="error-text text-danger">{formik.errors.confirm_password}</p>}
              </div>

              <button className="btn btn-pri min-w-[181px]" type="submit">
                {t("btn_submit")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
